import moment, { Moment } from 'moment';
import { useState } from 'react';
import { useLocation } from 'react-router';
import { getWeekStartDate } from 'components/organisms/timesheets/common/utils';
import { WeekPreset } from 'components/organisms/timesheets/types';
import { date, DayOfWeek } from 'core/day-of-week';

export const useApprovalTabDate = (): {
  approvalTabStartDate: Moment;
  setApprovalTabStartDate: (value: Moment) => void;
} => {
  const { pathname } = useLocation();
  const weekInUrl = pathname.split('timesheets/')[1]?.split('/')[0];
  const isWeekInUrlValid =
    moment(weekInUrl, 'YYYY-MM-DD').isValid() ||
    [WeekPreset.ThisWeek, WeekPreset.PreviousWeek].includes(
      weekInUrl as WeekPreset,
    );
  const [approvalTabStartDate, setApprovalTabStartDate] = useState<Moment>(
    isWeekInUrlValid && pathname.indexOf('/approvals') !== -1
      ? getWeekStartDate(weekInUrl)
      : date(DayOfWeek.Monday, moment()),
  );

  return {
    approvalTabStartDate,
    setApprovalTabStartDate,
  };
};
